import React from "react";
import { render } from "react-dom";

import { configure } from "mobx";
import Cookies from "js-cookie";
import { BrowserRouter as Router } from "react-router-dom";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";

import "~/styles/index.scss";
import { ThemeProvider } from "@mui/material";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "~/theme";

import App from "~/App";
import RootStore from "~/store/RootStore";
import { StoreContext } from "~/context";
import config from "~/config";
import amplitude from "~/services/amplitude";

(window as any).amplitude = amplitude;

configure({
  reactionScheduler: (fn: () => void) => {
    setTimeout(fn, 1);
  },
  enforceActions: "never",
});

Sentry.init({
  dsn: config.sentryUrl,
  integrations: [new Integrations.BrowserTracing()],
  tracesSampleRate: 0,
});

export const store = new RootStore();

Cookies.set(config.api.tokenKey, config.api.tokenValue);

const root = document.getElementById("root");
render(
  <>
    <CssBaseline />
    <StoreContext.Provider value={store}>
      <ThemeProvider theme={theme}>
        <Router>
          <App />
        </Router>
      </ThemeProvider>
    </StoreContext.Provider>
  </>,
  root
);
